export enum ContractState {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  END_BILLING = 'END_BILLING',
}
